import { render, staticRenderFns } from "./CloseAlarmLamp.vue?vue&type=template&id=29812a4d&"
import script from "./CloseAlarmLamp.vue?vue&type=script&lang=ts&"
export * from "./CloseAlarmLamp.vue?vue&type=script&lang=ts&"
import style0 from "./CloseAlarmLamp.vue?vue&type=style&index=0&id=29812a4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports